import React from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { HomePage } from "@/pages/HomePage";
import { AboutPage } from "@/pages/AboutPage";
import { LeadershipPage } from "@/pages/LeadershipPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage";
import { TermsPage } from "@/pages/TermsPage";
import { FAQPage } from "@/pages/FAQPage";
import { ProductDetailPage } from "@/pages/ProductDetailPage";
import { CalculatorPage } from "@/pages/CalculatorPage";
import { ContactPage } from "@/pages/ContactPage";
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import { AdminDashboardPage } from "@/pages/AdminDashboardPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";
import { AccessibilityWidget } from "@/components/AccessibilityWidget";
import { Toaster } from "@/components/ui/sonner";
import { ApplicationModalProvider } from "@/context/ApplicationModalContext";
import { ApplicationModal } from "@/components/ApplicationModal";
import { ApplicationRedirect } from "@/components/ApplicationRedirect";
import { applyLegacyRedirect } from "@/utils/legacyRedirects";

// Legacy Wix → Emergent URL redirects. Runs BEFORE React mounts so bots
// that briefly see the SPA shell still end up on the canonical URL. Any
// URL not in the map falls through to <NotFoundPage> with noindex.
applyLegacyRedirect();

// Wraps public routes with Header, semantic <main> for skip-to-content, and Footer.
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main id="main-content" tabIndex={-1} className="focus:outline-none">
      {children}
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <a href="#main-content" className="a11y-skip-link" data-testid="skip-to-main">
          Əsas məzmuna keç
        </a>
      <BrowserRouter>
        <ApplicationModalProvider>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/haqqimizda/biz-kimik" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/haqqimizda/rehberlik" element={<PublicLayout><LeadershipPage /></PublicLayout>} />
            <Route path="/haqqimizda/hesabatlar" element={<PublicLayout><ReportsPage /></PublicLayout>} />
            <Route path="/mehsullar/:slug" element={<PublicLayout><ProductDetailPage /></PublicLayout>} />
            <Route path="/kalkulator" element={<PublicLayout><CalculatorPage /></PublicLayout>} />
            <Route path="/elaqe" element={<PublicLayout><ContactPage /></PublicLayout>} />
            <Route path="/faq" element={<PublicLayout><FAQPage /></PublicLayout>} />
            <Route path="/mexfilik-siyaseti" element={<PublicLayout><PrivacyPolicyPage /></PublicLayout>} />
            <Route path="/istifade-shertleri" element={<PublicLayout><TermsPage /></PublicLayout>} />

            {/* Legacy /muraciet URL — opens the modal on homepage for backward compatibility */}
            <Route path="/muraciet" element={<ApplicationRedirect />} />

            {/* Admin Routes */}
            <Route path="/ascorpadmin/entry" element={<AdminLoginPage />} />
            <Route path="/ascorpadmin/dashboard" element={<AdminDashboardPage />} />

            {/* Catch-all 404 */}
            <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
          </Routes>
          <CookieConsentBanner />
          <ApplicationModal />
          <AccessibilityWidget />
          <Toaster />
        </ApplicationModalProvider>
      </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
